'use client'

import React from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { Inbox } from 'lucide-react'

interface EmptyStateProps {
  title: string
  description?: string
  actionLabel?: string
  onAction?: () => void
  className?: string
}

/**
 * 공통 빈 상태 컴포넌트
 * 견적서가 없을 때, 필터 결과가 없을 때 등에 사용
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
  className,
}) => {
  return (
    <Card className={cn('border-dashed', className)}>
      <CardContent className="flex flex-col items-center justify-center gap-3 py-10 text-center">
        <div className="rounded-full border bg-muted/30 p-3">
          <Inbox className="h-5 w-5 text-muted-foreground" />
        </div>

        <div className="space-y-1">
          <h3 className="text-base font-semibold">{title}</h3>
          {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
        </div>

        {actionLabel && onAction ? (
          <Button variant="secondary" onClick={onAction} className="whitespace-nowrap py-3 px-6 text-sm leading-tight min-h-9">
            {actionLabel}
          </Button>
        ) : null}
      </CardContent>
    </Card>
  )
}


